import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export const PPP_COMPLAINT_CATEGORIES = ["Masa aktif tidak sesuai", "Seharusnya online tapi offline", "Kabel putus", "Internet tidak tersedia", "Lainnya"];

export function PppComplaintDialog({ item, routerId, onClose }) {
  const [category, setCategory] = useState(PPP_COMPLAINT_CATEGORIES[0]);
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  if (!item) return null;
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ppp/complaints", { router_id: routerId, secret_name: item.name, category, description: desc, expired_date: item.expired_date || "", profile: item.profile || "" });
      toast.success(`Komplain #${data.ticket_no} terkirim ke ${data.sent_to.join(" & ")}`);
      onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="ppp-complaint-dialog">
        <DialogHeader>
          <DialogTitle>Komplain Pelanggan — {item.name}</DialogTitle>
          <DialogDescription className="font-mono text-xs">{item.profile || "-"} • expired: {item.expired_date ? fmtDate(item.expired_date) : "belum di-setup"}. Pesan langsung dikirim ke admin dan upline Anda.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1">
            <Label>Masalah</Label>
            <div className="flex flex-wrap gap-1.5">
              {PPP_COMPLAINT_CATEGORIES.map((c) => (
                <button key={c} type="button" onClick={() => setCategory(c)} className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${category === c ? "bg-rose-500/20 border-rose-500 text-rose-300" : "border-border hover:bg-muted"}`} data-testid={`ppp-complaint-cat-${c.replace(/\s+/g, "-").toLowerCase()}`}>{c}</button>
              ))}
            </div>
          </div>
          <div className="space-y-1">
            <Label>Keterangan {category === "Lainnya" ? "(wajib)" : "(opsional)"}</Label>
            <Textarea rows={3} value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Contoh: sudah bayar tgl 10 tapi status masih offline / kabel putus di depan rumah…" data-testid="ppp-complaint-desc" />
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={onClose} data-testid="ppp-complaint-cancel">Batal</Button>
            <Button disabled={busy || (category === "Lainnya" && desc.trim().length < 5)} onClick={submit} className="bg-rose-600 hover:bg-rose-500 text-white" data-testid="ppp-complaint-submit">{busy ? "Mengirim…" : "Kirim Komplain"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
